import styled from "styled-components";

export const Container = styled.div`
  @media print {
    @page {
      margin: 0;
    }
    body {
      margin: 1.6cm;
    }
  }
  width: 794px;
  height: 1123px;
  min-height: 1123px;
  padding: 24px;
  background: #fff;
  & input {
    border: 0px solid #00bebe;
    border-radius: 8px;
    padding: 8px;
    margin: -8px;
    background: transparent;
  }
  @media print {
    & input {
      border: 0px solid #000;
    }
  }
`;

export const ContainerActions = styled.div`
  padding: 5px;
  width: 300px;
  z-index: 100;
  position: fixed;
  top: 0px;
  left: 50%;
  display: flex;
  gap: 12px;
  background: #00bebe;
  transform: translate(-50%, 0);
  @media print {
    & {
      display: none;
    }
  }
`;
